import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './TeamHero.css';

function TeamHero() {
  const { language } = useLanguage();

  return (
    <section
      className="team-hero"
      id="team-hero"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/grupo-bg.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#1a1a1a'
      }}
    >
      <div className="team-hero-overlay"></div>
      <div className="container">
        <div className="teamhero-content">
          <div className="teamhero-text">
            <h1 className="teamhero-title">{language === 'en' ? 'Team' : 'Equipo'}</h1>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TeamHero;
